module.exports = __webpack_public_path__ + "img/ic-discord.94ad797b.svg";